export const CHILIPIPER_SDK_URL = 'https://ramp-com.chilipiper.com/concierge-js/cjs/concierge.js'
